import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ebb9a49c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ebb9a49c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb9a49c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebb9a49c')) {
      api.createRecord('ebb9a49c', component.options)
    } else {
      api.reload('ebb9a49c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ebb9a49c&scoped=true&", function () {
      api.rerender('ebb9a49c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormItem/pagination/index.vue"
export default component.exports